// Show the first tab and hide the rest
$('#collection_tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#collection_tabs-nav li').click(function(){
  $('#collection_tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

// Verticle Swiper Slider
var swiper = new Swiper('.verticle-slider', {
    speed: 1200,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + ( (index + 1)) + '</span>';
      }
    }
});

// Testimonials Slider
new Swiper('.testimonial_slider', {
    loop: true,
    slidesPerView: 'auto',
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    paginationClickable: true,
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
});

// Accordion
$(function() {
  $('.acc__title').click(function(j) {    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.accordion').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.accordion').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

// Collection Filter
$(document).ready(function(){
    $(".more_filtter_toggle").click(function(){
        $(".mobile-facets__open-wrapper").trigger('click');
    });
});

// Collection product grid
document.addEventListener('DOMContentLoaded', () => {
  const storageKey = 'gridViewPreference';

  function applySavedGridLayout() {
    const savedView = localStorage.getItem(storageKey);
    const grid = document.querySelector('#product-grid');
    if (!grid || !savedView) return;

    // Remove all grid classes
    grid.classList.remove(
      'grid--1-col-desktop',
      'grid--2-col-desktop',
      'grid--2-col-desktop',
      'grid--4-col-desktop',
      'grid--5-col-desktop',
      'grid--list'
    );

    // Add saved layout
    grid.classList.add(...savedView.split(' '));

    // Update active icon
    document.querySelectorAll('.grid-icon').forEach(i => i.classList.remove('active'));
    if (savedView.includes('grid--4-col-desktop')) {
      document.querySelector('.grid-icon.default_column')?.classList.add('active');
    } else if (savedView.includes('grid--2-col-desktop')) {
      document.querySelector('.grid-icon.two_column')?.classList.add('active');
    } else if (savedView.includes('grid--1-col-desktop')) {
      document.querySelector('.grid-icon.list_column')?.classList.add('active');
    }
  }

  function attachGridEvents() {
    const icons = document.querySelectorAll('.grid-icon');
    const grid = document.querySelector('#product-grid');
    if (!grid || icons.length === 0) return;

    icons.forEach(icon => {
      icon.addEventListener('click', () => {
        icons.forEach(i => i.classList.remove('active'));
        icon.classList.add('active');

        grid.classList.remove(
          'grid--1-col-desktop',
          'grid--2-col-desktop',
          'grid--2-col-desktop',
          'grid--4-col-desktop',
          'grid--5-col-desktop',
          'grid--list'
        );

        let newView = '';

        if (icon.classList.contains('default_column')) {
          newView = 'grid--4-col-desktop';
        } else if (icon.classList.contains('two_column')) {
          newView = 'grid--2-col-desktop';
        } else if (icon.classList.contains('list_column')) {
          // 👇 Add both list classes
          newView = 'grid--1-col-desktop grid--list';
        }

        if (newView) {
          grid.classList.add(...newView.split(' '));
          localStorage.setItem(storageKey, newView);
        }
      });
    });
  }

  // Run initially
  applySavedGridLayout();
  attachGridEvents();

  // Handle AJAX reloads from sorting/filtering
  const reapply = () => {
    setTimeout(() => {
      applySavedGridLayout();
      attachGridEvents();
    }, 100);
  };

  document.addEventListener('shopify:section:load', reapply);
  document.addEventListener('shopify:section:render', reapply);
  document.addEventListener('facet:updated', reapply);

  // Fallback for dynamic updates
  const observer = new MutationObserver(reapply);
  const gridParent = document.querySelector('.collection, .collection__content, main');
  if (gridParent) {
    observer.observe(gridParent, { childList: true, subtree: true });
  }
});

// Product note
$(document).ready(function(){
  $('#display_pro_notes').on('input', function(){
    $('#pro_notes').val($(this).val());
  });

  // Optional: copy initial value on load
  $('#pro_notes').val($('#display_pro_notes').val());
});

// Change product image on swatch click
document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".product-siblings__item");
  if (!swatch) return;

  const card = swatch.closest(".product-card-wrapper");
  if (!card) return;

  const newMain = swatch.dataset.image;
  const newHover = swatch.dataset.hoverImage;
  const newUrl = swatch.dataset.url;
  const newTitle = swatch.dataset.title;
  const newSku = swatch.dataset.sku;
  const newPrice = swatch.dataset.price;
  const newCompare = swatch.dataset.comparePrice;
  const hasRange = swatch.dataset.hasRange === "true";
  const newBadge = swatch.dataset.badge;

  // Add "From " only if variants have different prices
  const prefix = hasRange ? "From " : "";

  // ✅ Update images
  card.querySelectorAll(".card__media img").forEach((img, i) => {
    const newSrc = (i === 1 && newHover) ? newHover : newMain;
    if (!newSrc) return;

    img.src = newSrc;
    img.srcset = "";
    img.removeAttribute("data-src");
    img.removeAttribute("data-widths");
    img.removeAttribute("data-srcset");
    img.removeAttribute("data-media-id");
  });

  // ✅ Update product URL
  card.querySelectorAll("a.full-unstyled-link").forEach(link => {
    link.href = newUrl;
  });

  // ✅ Update title (all instances)
  card.querySelectorAll(".card__heading a, .card__heading").forEach(el => {
    el.textContent = newTitle;
  });

  // ✅ Update SKU (all instances)
  card.querySelectorAll(".card__sku").forEach(el => {
    el.textContent = `Sku# ${newSku}`;
  });

  // ✅ Update price + compare price
  const priceContainer = card.querySelector(".price");
  const regEl = card.querySelector(".price-item--regular");
  const saleEl = card.querySelector(".price-item--sale, .price-item--last");

  if (newCompare && saleEl && regEl) {
    regEl.textContent = prefix + newCompare;
    saleEl.textContent = prefix + newPrice;
    regEl.style.display = "inline";
    saleEl.style.display = "inline";
    priceContainer?.classList.add("price--on-sale");
  } else {
    if (regEl) {
      regEl.textContent = prefix + newPrice;
      regEl.style.display = "inline";
    }
    if (saleEl) saleEl.style.display = "none";
    priceContainer?.classList.remove("price--on-sale");
  }

  // ✅ Update badge
  const badgeEl = card.querySelector(".badge, .card__badge span");
  if (badgeEl) {
    if (newBadge) {
      badgeEl.textContent = newBadge;
      badgeEl.style.display = "inline-block";
    } else {
      badgeEl.style.display = "none";
    }
  }

  // ✅ swatch active state
  card.querySelectorAll(".product-siblings__item").forEach(item => item.classList.remove("active"));
  swatch.classList.add("active");
});


// Verticle Slideshow
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".vertical-main .vertical-right .image-with-text__text-item");
  const images = document.querySelectorAll(".vertical-main .vertical-left .image-with-text__media");
  const bullets = document.querySelectorAll(".pagination-bullets .bullets-boxs");

  // ===== Scroll Event Logic =====
  document.addEventListener("scroll", () => {
    let currentIndex = 0;

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= 0) {
        currentIndex = index;
      }
    });

    // Toggle active for sections
    sections.forEach((section, idx) => {
      section.classList.toggle("active", idx === currentIndex);
    });

    // Toggle active for images
    images.forEach((img, idx) => {
      img.classList.toggle("active", idx === currentIndex);
    });

    // Toggle active for bullets
    bullets.forEach((bullet, idx) => {
      bullet.classList.toggle("active", idx === currentIndex);
    });
  });

  // ===== Click-to-Scroll Logic =====
  bullets.forEach((bullet, idx) => {
    bullet.addEventListener("click", (e) => {
      e.preventDefault(); // prevent default <a> behavior

      // Get the target section
      const target = sections[idx];
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "center" // scroll so it's nicely centered
        });
      }
    });
  });
});